<template>
  <div :class="ui.popup.class_name" v-if="isOpen">
    <div class="popup-box" :style="'width: ' + width + '; top: ' + top + ';'">
      <div class="popup-body">
        <Icon @click="isOpen = false" type="md-close" class="popup-close" />
        <div class="popup-title" v-if="title">
          {{ title }}
        </div>
        <div class="popup-content" v-html="content" v-if="content"></div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'UiPopup',
  components: {
  },
  props: {
    width: {
      type: String,
      default: '90%'
    },
    top: {
      type: String,
      default: '100px'
    },
    ui: {
      type: Object
    },
    closeFunction: {
      type: Function,
      required: false
    }
  },
  data () {
    return {
      isOpen: false,
      titleMsg: '',
      content: ''
    }
  },
  computed: {
  },
  watch: {
    'isOpen': function () {
      if (!this.isOpen) {
        this.content = ''
        if (this.$props.closeFunction) {
          this.$props.closeFunction()
        }
      }
    }
  },
  methods: {
    close () {
      this.isOpen = false
    },
    open (title) {
      this.title = title
      this.isOpen = true
    },
    openMsg (title, content) {
      this.isOpen = true
      this.title = title
      this.content = content
    }
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/popup.vue